module.exports = __webpack_public_path__ + "img/hill-tree.fa542501.png";